import type { AiCustomPart, AiMessagePart } from 'juneau';
import type { ApprovalStatus, CompletionCondition } from '@insio/shared-types';

export interface InvoiceDetailLine {
  lineNumber: number | null;
  description: string | null;
  quantity: number | null;
  unit: string | null;
  /** Financial amounts are Decimal strings — parse with new Decimal(x) when math is needed. */
  unitPrice: string | null;
  totalAmountNoVat: string | null;
  totalAmountInclVat: string | null;
  vatRate: string | null;
}

export interface InvoiceDetailHistoryEntry {
  eventType: string;
  fieldName: string | null;
  fromValue: string | null;
  toValue: string | null;
  comment: string | null;
  changedAt: string;
  changedBy: string | null;
}

export interface InvoiceDetailPartType extends AiCustomPart {
  type: 'invoice-detail';
  invoiceId: string;
  invoiceNumber: string | null;
  documentType: string | null;
  supplierName: string | null;
  supplierVatId: string | null;
  customerName: string | null;
  invoiceDate: string | null;
  dueDate: string | null;
  taxDate: string | null;
  /** Financial amounts are Decimal strings — parse with new Decimal(x) when math is needed. */
  totalAmountNoVat: string | null;
  totalAmountInclVat: string | null;
  totalVatAmount: string | null;
  currencyCode: string | null;
  /** Absent on cards stored before the approval status was carried; such a card shows no badge. */
  approvalStatus?: ApprovalStatus | null;
  isCancelled?: boolean;
  isCompleted?: boolean;
  unmetCompletionConditions?: CompletionCondition[];
  validationStatus: string | null;
  paymentStatus: string | null;
  paidAmount: string | null;
  paidDate: string | null;
  paymentMethod: string | null;
  description: string | null;
  internalNumber: string | null;
  lines: InvoiceDetailLine[];
  history: InvoiceDetailHistoryEntry[];
}

export function isInvoiceDetailPart(part: AiMessagePart): part is InvoiceDetailPartType {
  return (
    part.type === 'invoice-detail' &&
    typeof (part as InvoiceDetailPartType).invoiceId === 'string' &&
    Array.isArray((part as InvoiceDetailPartType).lines) &&
    Array.isArray((part as InvoiceDetailPartType).history)
  );
}
